import React, {
  createContext,
  useEffect,
  useMemo,
  useState
} from "react";
//prueba
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [cargandoAuth, setCargandoAuth] = useState(true);
  const [usuario, setUsuario] = useState(null);
  const [token, setToken] = useState(null);

  // 👇 nuevo: modal sesión expirada
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  /* ===============================
     CARGA INICIAL
  ================================ */
  useEffect(() => {
    try {
      const savedUser = localStorage.getItem("usuario");
      const savedToken = localStorage.getItem("token");

      if (savedUser && savedToken) {
        setUsuario(JSON.parse(savedUser));
        setToken(savedToken);
      }
    } catch (_) {
    } finally {
      setCargandoAuth(false);
    }
  }, []);

  /* ===============================
     LOGOUT GLOBAL (AXIOS)
  ================================ */
  useEffect(() => {
    const handleLogout = () => {
      setUsuario(null);
      setToken(null);
      localStorage.removeItem("usuario");
      localStorage.removeItem("token");

      // 👇 mostrar modal
      setShowLogoutModal(true);
    };

    window.addEventListener("logout", handleLogout);
    return () => window.removeEventListener("logout", handleLogout);
  }, []);

  /* ===============================
     LOGIN / LOGOUT MANUAL
  ================================ */
  const login = (userData, tokenData) => {
    setUsuario(userData);
    setToken(tokenData);
    localStorage.setItem("usuario", JSON.stringify(userData));
    localStorage.setItem("token", tokenData);
  };

  const cerrarSesion = () => {
    setShowLogoutModal(false);
    window.location.replace("/login");
  };

  const value = useMemo(
    () => ({
      usuario,
      token,
      login,
      cargandoAuth,
      showLogoutModal,
      cerrarSesion
    }),
    [usuario, token, cargandoAuth, showLogoutModal]
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
